<template>
  <div class="home">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#">DocSigner</b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-button size="sm" variant="info" to="/config">
          <img src="img/cog.svg" alt="Config" width="16px">
        </b-button>
      </b-navbar-nav>
    </b-navbar>
    <ShowDocument />
    <Signature />
    <!--
    <p style="padding-top: 20px;">
      <b-alert variant="info" show>{{ userAgent }}</b-alert>
    </p>
    -->
  </div>
</template>

<script>
  import ShowDocument from '../components/ShowDocument'
  import Signature from '../components/Signature'

  export default {
    name: 'Home',
    components: {
      ShowDocument,
      Signature
    },
    data() {
      return {
        userAgent: null
      };
    },
    created() {
      this.userAgent = window.navigator.userAgent;
    }
  }
</script>

<style scoped>
  .home {
    background-color: aliceblue;
  }
</style>
